// @flow
import React from 'react';
import classNames from 'classnames';
import { ContactDetails } from 'components/organisms/contactDetails';
import { ContactUsForm } from 'components/organisms/contactUsForm';
import { useViewport } from 'components/templates/viewportProvider';
import type { Contact, Vertical } from 'types/common';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  data: {
    contact: Contact,
    verticals: Array<Vertical>,
    verticalId: number | null,
    projectName?: string,
    showVerticalDropdown?: boolean,
    callPostLeadAPI?: boolean,
  },
};

export const ContactUsSection = (props: Props) => {
  const { height, isMobile } = useViewport();
  const {
    contact,
    verticals,
    verticalId,
    projectName,
    showVerticalDropdown,
    callPostLeadAPI,
    type,
    origin,
    referenceNumber,
    rentalName,
    rental,
  } = props.data;
  const containerClass = classNames({
    'no-padding': isMobile,
    'section-container': !isMobile,
  });
  const fetchUrl = window.location.href;
  const url = new URL(fetchUrl);
  const utmParameters = {
    UTMSource: url.searchParams.get('utm_source'),
    UTMMedium: url.searchParams.get('utm_medium'),
    UTMCampaign: url.searchParams.get('utm_campaign'),
    UTMDisplay: url.searchParams.get('utm_display'),
    UTMTerm: url.searchParams.get('utm_term'),
    UTMContent: url.searchParams.get('utm_content'),
    CampaignCode: contact.campaignCode ? contact.campaignCode : '',
    ProjectInterested: projectName ? projectName : '',
  };

  return (
    <div
      className={containerClass}
      style={isMobile ? { height: '130vh !important' } : { height: parseInt(height, 10) <= 670 ? '670px' : height }}
      id={'contact'}
    >
      <div
        className={
          isMobile
            ? type === 'no-padding'
              ? 'contact-container '
              : 'contact-container'
            : 'contact-container'
        }
      >
        <div className={'info-container'}>
          <ContactDetails contact={contact} />
        </div>
        <div className={'contact-form-container'}>
          <ContactUsForm
            verticals={verticals}
            verticalId={verticalId}
            isMobile={isMobile}
            utmParameters={utmParameters}
            showVerticalDropdown={showVerticalDropdown}
            contactEmail={contact.email}
            callPostLeadAPI={callPostLeadAPI}
            origin={origin}
            rentalName={rentalName}
            referenceNumber={referenceNumber}
            isRental={rental}
          />
        </div>
      </div>
    </div>
  );
};
